import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Simplified modal state - only needs image URL
export interface ModalState {
  isOpen: boolean;
  imageUrl?: string;
  title?: string;
  altText?: string;
}

const initialState: ModalState = {
  isOpen: false,
  imageUrl: undefined,
  title: undefined,
  altText: undefined,
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,

  reducers: {
    // Single action to open modal with image
    openImageModal: (
      state,
      action: PayloadAction<{
        imageUrl: string;
        title?: string;
        altText?: string;
      }>
    ) => {
      state.isOpen = true;
      state.imageUrl = action.payload.imageUrl;
      state.title = action.payload.title;
      state.altText = action.payload.altText;
    },

    // Simple close action
    closeModal: state => {
      state.isOpen = false;
      state.imageUrl = undefined;
      state.title = undefined;
      state.altText = undefined;
    },
  },
});

// Export actions - only need these two
export const { openImageModal, closeModal } = modalSlice.actions;

// Export reducer
export default modalSlice.reducer;
